const KeenSlider = window.KeenSlider

const { setInitialised, useDots, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return
    if (this.els.slide.elements.length <= 1) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        setInitialised(),
        useDots(this.els?.dot?.elements),
        addWheelControls('horizontal'),
      ],
    )
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
